var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.text)?_c('div',{staticClass:"sponsor-badge",style:({
		top: _vm.top,
		right: _vm.right,
		left: _vm.left,
		bottom: _vm.bottom,
		position: 'absolute',
		backgroundColor: _vm.background,
		color: _vm.color,
		maxWidth: _vm.width + 'px',
	})},[(_vm.icon)?_c('Icon',{staticClass:"mr-1",attrs:{"type":_vm.icon,"size":_vm.iconSize,"color":_vm.iconColor}}):_vm._e(),_vm._v(" "+_vm._s(_vm.text)+" ")],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }